// Suppress benign ResizeObserver warnings from Radix UI so the CRA dev overlay
// never intercepts clicks in the preview environment.
const _resizeObserverErr = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (_resizeObserverErr.test(e.message)) e.stopImmediatePropagation();
});
window.addEventListener("unhandledrejection", (e) => {
  if (_resizeObserverErr.test(e.reason?.message || "")) e.preventDefault();
});

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
